"use client";
import SvgCupraSymbol from "./cupra_symbol.svg.js";
import SvgCupraWordmark from "./cupra_wordmark.svg.js";
const cupra = {
  key: "cupra",
  symbol: SvgCupraSymbol,
  wordmark: SvgCupraWordmark
};
export {
  cupra
};
